import { BranchSelectItem } from './types';

/** Normalize CustomSelect eventKey (string | null) to number | null. */
export function parseGotoBranchId(raw: unknown): number | null {
  if (raw == null || raw === '' || raw === 'null') return null;
  const num = Number(raw);
  return Number.isNaN(num) ? null : num;
}

export function getBranchName(branchId: number | null, branches: BranchSelectItem[]): string {
  if (branchId == null) return '';
  if (branchId === -1) return '[Create New Node]';
  const branch = branches.find((b) => b.id === branchId);
  return branch ? branch.title : '';
}
